exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UploadLoader{position:fixed;width:100%;height:100%;background-color:#f7f8fc;display:flex;align-items:center;justify-content:center}.UploadLoader .progress{position:relative}.UploadLoader .progress img,.UploadLoader .progress .CircularProgress{position:absolute}.UploadLoader .progress img{left:calc(50% - 32px);top:calc(50% - 33.68px)}.UploadLoader .options{margin:24px 0;display:flex;flex-direction:column;justify-content:center;text-align:center}.UploadLoader .options button{background-color:transparent;border:none;margin:8px;color:#EB6878}\n", ""]);

// exports
